import { useRef, useEffect } from 'react';

/**
 * Use to access the previous value of a local state property.
 *
 * @param {*} value - state variable name
 * @return {*} previous value of the state variable
 *
 * @example
 * function Counter() {
 *   const [count, setCount] = useState(0);
 *   return <p>Now: {count}, before: {usePrevious(count)}</p>;
 * }
 */

export function usePrevious<T>(state: T): T | undefined {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = state;
  });

  return ref.current;
}

export default usePrevious;
